import React, { useMemo } from 'react'

import ItineraryItemCard from './ItineraryItemCard'

import BodyText from 'components/Luxkit/Typography/BodyText'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import { ActivityItem, ThingToDoItem } from 'tripPlanner/types/tripItem'
import {
  formatDaysAndTime,
  formatShortDateAndTimeRange,
} from 'tripPlanner/utils'

interface Props {
  item: ActivityItem | ThingToDoItem
}

export default function ActivityItemCard({ item }: Props) {
  const {
    startDay,
    endDay,
    startDate,
    startTime,
    endDate,
    endTime,
    confirmationCode,
  } = item
  const isSameEndPlace =
    'id' in item.startPlace &&
    'id' in item.endPlace &&
    item.startPlace.id &&
    item.startPlace.id === item.endPlace.id

  const timeFormat = useRegionTimeFormat()

  const displayDates = useMemo(
    () =>
      startDay
        ? formatDaysAndTime({
            startDay,
            endDay,
            startTime,
            endTime,
            timeFormat,
          })
        : formatShortDateAndTimeRange({
            startDate,
            startTime,
            endDate,
            endTime,
            timeFormat,
          }),
    [endDate, endDay, endTime, startDate, startDay, startTime, timeFormat],
  )

  return (
    <ItineraryItemCard
      item={item}
      name={item.name}
      imgSrc={item.startPlace.photoUrl}
      placeId={'id' in item.startPlace ? item.startPlace.id : undefined}
      locationDescription={
        <>
          {isSameEndPlace && item.startPlace.name}
          {!isSameEndPlace && (
            <>
              Starts in&nbsp;
              <BodyText weight="bold" as="span" variant="small">
                {item.startPlace.name}
              </BodyText>
              , Ends in&nbsp;
              <BodyText weight="bold" as="span" variant="small">
                {item.endPlace.name}
              </BodyText>
            </>
          )}
        </>
      }
      descriptors={[displayDates]}
      address={item.startPlace.address}
      confirmationCode={confirmationCode}
      confirmationCodeLabel="Confirmation number"
    />
  )
}
